import { ITagQuery } from "../../models/tag/query";
import { ITag, ITagDetails } from "../../models/tag/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, TagLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: TagLoading | TagLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<ITag> } }
  | { type: "SET_DETAILS"; payload: { details?: ITagDetails } }
  | QueryAction<ITagQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
